import React from "react";

export default function PlusWithCircle(props) {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      width="612px"
      height="612px"
      viewBox="0 0 612 612"
      style={{ enableBackground: "new 0 0 612 612" }}
      xmlSpace="preserve"
      {...props}
    >
      <g>
        <g>
          <polygon points="319.909,486.818 319.909,319.909 486.818,319.909 486.818,292.091 319.909,292.091 319.909,125.182
            292.091,125.182 292.091,292.091 125.182,292.091 125.182,319.909 292.091,319.909 292.091,486.818"
          />
          <path d="M612,306C612,137.004,474.995,0,306,0C137.004,0,0,137.004,0,306c0,168.995,137.004,306,306,306
            C474.995,612,612,474.995,612,306z M27.818,306C27.818,152.36,152.36,27.818,306,27.818S584.182,152.36,584.182,306
            S459.64,584.182,306,584.182S27.818,459.64,27.818,306z"
          />
        </g>
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  );
}
